<template>
  <div>
    <component
      :is="component"
    />
  </div>
</template>
<script>
import Func20Declaracoes from '@/views/20/Func20Declaracoes.vue'

export default {
  name: 'Func20',
  data () {
    return {
      component: Func20Declaracoes
    }
  }
}
</script>
